import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AnnouncementBar from './components/AnnouncementBar';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
import Testimonials from './components/Testimonials';
import SqueezeForm from './components/SqueezeForm';
import Footer from './components/Footer';
import ThankYou from './pages/ThankYou';

const HomePage = () => (
  <div className="min-h-screen bg-[#FAF8F5] font-sans selection:bg-amber-100 selection:text-amber-900">
    <AnnouncementBar />
    <main>
      <Hero />
      <Benefits />
      <Testimonials />
      <SqueezeForm />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/obrigado" element={<ThankYou />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;